import React from 'react';

export default function LegalNotes(props: any) {
  const highlightEmails = (str: string) => {
    if (!str) {
      return str;
    }

    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
    const parts = str.split(emailRegex);

    return parts.map((part, index) =>
      emailRegex.test(part) ? (
        <a key={index} href={`mailto:${part}`} style={{ color: '#578591' }}>
          {part}
        </a>
      ) : (
        part
      ),
    );
  };

  return <p>{highlightEmails(props.text)}</p>;
}
